<template>
    <div id="main">
        <loading :isLoading="isLoading || vendedoresLoading" />
        <div class="page page-container">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{
                            !isUpdate
                                ? $t('adicionar') + ' ' + $t('nova-parametrizacao')
                                : $t('editar') + ' ' + $t('parametrizacao')
                        }}
                    </h1>

                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ $t('configs') }}</a>
                            </li>
                            <li>
                                <a @click="redirectToPage()">
                                    {{ $t('parametrizacoes') }}
                                </a>
                            </li>
                            <li>
                                <a aria-current="page">
                                    {{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t('adicionar') + ' ' + $t('parametrizacoes')
                                    }}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="
                            $router.push({
                                name: 'config-parametrizacoes',
                                query: { abaSelecionada: $route.query.abaSelecionada },
                            })
                        "
                    >
                        {{ $t('voltar') }}
                    </button>

                    <button class="save-btn" type="button" @click="save" :disabled="isLoading">
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isLoading" />
                    </button>
                </div>
            </div>
            <!-- VENDEDORES -->
            <div class="columns">
                <div class="column">
                    <vss-select
                        title="vendedor"
                        label="nome"
                        v-model="vendedorSelected"
                        :options="vendedoresOptions"
                        :loading="vendedoresLoading"
                        @search="SearchVendedores"
                        @input="clearSelect($event, 'vendedores')"
                        :comparedId="true"
                        :disabled="isUpdate || isLoading || vendedoresLoading"
                        noClearfix
                        searchable
                    />
                </div>
            </div>

            <!-- PARAMETRIZAÇÃO -->
            <div class="columns">
                <div class="column">
                    <vss-select
                        title="parametrizacao"
                        label="label"
                        ref="parametrizacoesInput"
                        class="nova-parametrizacao-select"
                        :options="configs"
                        v-model="configSelected"
                        :clearable="false"
                        @input="onCleanConfigs"
                        @search="searchConfigs"
                        :disabled="isUpdate || isLoading"
                        searchable
                        noClearfix
                    />
                </div>
            </div>

            <!-- VALOR -->
            <div class="columns">
                <div class="column conteudo-parametrizacao-valor">
                    <template>
                        <label v-text="$t('valor')" />
                        <v-select
                            v-if="options.length != 0"
                            ref="valorSelect"
                            label="label"
                            :options="options"
                            :clearable="false"
                            v-model="selected"
                            :disabled="isLoading"
                        />
                        <input
                            v-else
                            v-model="inputText"
                            :type="typeInput"
                            required
                            :value="typeInput === 'number' ? inputText : ''"
                            :disabled="isLoading"
                        />
                    </template>
                </div>
            </div>
            <!-- DESCRIÇÃO -->
            <div class="columns content">
                <div class="column">
                    <v-textarea
                        ref="obsTextArea"
                        class="obs-ta"
                        v-model="descricao"
                        title="descricao"
                        :maxlength="isUpdate ? descricao.length : 2000"
                        readonly
                        disabled
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ParametrizacaoUsuarioService from '@/services/ParametrizacaoUsuarioService';
import ParametrizacaoService from '@/services/ParametrizacaoService';
import ColaboradorService from '@/services/ColaboradorService';

export default {
    data() {
        return {
            isLoading: false,
            service: new ParametrizacaoUsuarioService(this.$http, this.$router),
            serviceConfig: new ParametrizacaoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            selected: null,
            options: [],
            configs: [],
            vendedoresOptions: [],
            vendedoresLoading: false,
            vendedorSelected: null,
            usrsConfigs: [],
            configSelected: null,
            descricao: '',
            title: '',
            isExpanded: false,
            isUpdate: false,
            inputText: '',
            typeInput: 'text',
        };
    },
    props: {
        id: {
            type: Number,
            default: null,
        },
        idusuario: {
            type: Number,
            default: null,
        },
        config: {
            type: String,
            default: null,
        },
    },
    mounted() {
        if (this.id) {
            this.isUpdate = true;
        }
    },
    created() {
        // Define se é edição ou criação
        this.isUpdate = !!this.id;

        // Define o título
        this.title = this.isUpdate
            ? this.$t('editar') + ' ' + this.$t('parametrizacao')
            : this.$t('nova-parametrizacao');

        if (this.isUpdate) {
            // Aqui usa o nome da parametrização e o ID do usuário
            this.getDadosEdit(this.nomeParametrizacao, this.idusuario || null);
            this.getVendedorByIdEdit(this.idusuario);
        } else {
            this.loadConfigs();
            this.loadVendedores();
        }
    },
    methods: {
        getDadosEdit(parametrizacaoNome, idusuario) {
            this.isLoading = true;
            if (!parametrizacaoNome) return; // não tenta carregar sem nome
            this.$axios
                .get(`config/parametrizacao/${parametrizacaoNome}/${idusuario}.json`)
                .then((response) => {
                    if (response && response.data && response.data.content) {
                        const data = response.data.content;
                        this.configSelected = {
                            id: data.idconfig,
                            label: data.label || data.nome || '',
                            nome: data.nome,
                            descricao: data.descricao,
                            tipo: data.tipo,
                            situacao: data.situacao,
                            idcategoriaconfig: data.idcategoriaconfig,
                            valor: data.valor,
                        };
                        this.configs = [this.configSelected];
                        this.newRenderInput(this.configSelected);
                        this.descricao = data.descricao;
                        if (data.valor) {
                            this.selected =
                                this.options.find((opt) => opt.id == data.valor) || null;
                            this.inputText = data.valor;
                        }
                    } else {
                        this.configs = [];
                        this.configSelected = null;
                    }
                })
                .catch((error) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getVendedorByIdEdit(idusuario) {
            this.vendedoresLoading = true;
            this.vendedoresOptions = [];
            return this.$axios
                .get(`employees/${idusuario}.json`)
                .then((r) => {
                    this.vendedoresOptions = [r.data.content];
                    this.vendedorSelected = r.data.content; // agora 1 só
                    this.vendedoresLoading = false;
                })
                .catch(() => {
                    this.$root.showMessage('error', 'msg-erro-load');
                });
        },
        renderInput() {
            if (this.parametrizacaoUsuario.tipo && this.parametrizacaoUsuario.tipo === 'select') {
                let json = JSON.parse(this.parametrizacaoUsuario.tipo);
                this.options = json.options;
                this.selected = this.options.find(
                    (e) => e.name === this.parametrizacaoUsuario.valor
                );
            }
        },
        newRenderInput(value) {
            if (value.tipo) {
                let json = JSON.parse(value.tipo);
                if (json.type === 'select') {
                    this.options = json.options.map((e) => ({
                        id: e.value,
                        label: e.name,
                    }));
                    // NÃO setar selected aqui!
                } else {
                    this.typeInput = json.type;
                    this.inputText = json.type === 'number' ? 0 : '';
                }
            }
        },
        carregarVendedoresSelected() {
            const thisVm = this;
            this.vendedoresSelected = this.vendedoresOptions.filter(({ idusuario }) =>
                thisVm.usrsConfigs.some(
                    ({ idusuario: idusuarioConfigs }) => idusuarioConfigs === idusuario
                )
            );
        },
        loadVendedores() {
            this.vendedoresLoading = true;
            this.colaboradorService
                .findListAssociated('', 5000000)
                .then((r) => {
                    this.vendedoresOptions = r.content;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                    if (this.isUpdate) this.getUsersConfigsByNameAndValue();
                });
        },
        SearchVendedores(q) {
            this.vendedoresLoading = true;
            this.colaboradorService
                .findListAssociated(q, 5000000)
                .then((r) => {
                    this.vendedoresOptions = r.content.filter(
                        (vendedor) => vendedor.nome !== 'Todos'
                    );
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        save() {
            // validações básicas
            if (this.options.length === 0 && this.isNull(this.inputText)) {
                this.$root.showMessage('warning', 'msg-campo-valor', true);
                return;
            } else if (this.options.length > 0 && this.isNull(this.selected.id)) {
                this.$root.showMessage('warning', 'msg-campo-valor', true);
                return;
            }

            // valida se escolheu vendedor
            if (!this.vendedorSelected) {
                this.$root.showMessage('warning', 'Selecione um vendedor antes de salvar.', true);
                return;
            }

            this.isLoading = true;

            // monta objeto de configuração para 1 vendedor
            const obj = {
                ...this.configSelected,
                idusuario: this.vendedorSelected.idusuario,
                idconfigusuario: this.id,
                valor: this.selected && this.selected.id ? this.selected.id : this.inputText,
            };
            this.$axios
                .post('/config/usuario/save', obj)
                .then((res) => {
                    if (res.data.content == null) {
                        this.$root.showMessage('error', 'erro-edit-parametrizacao', true);
                    } else {
                        this.$root.showMessage('success', 'sucesso-edit-parametrizacao', true);
                        setTimeout(() => {
                            this.$router.push({
                                name: 'config-parametrizacoes',
                                query: { abaSelecionada: this.$route.query.abaSelecionada },
                            });
                        }, 1000);
                    }
                })
                .catch((e) => {
                    console.log('e',e.status === 409)
                    if (e.response || e.status === 409) {
                        const msg = this.$t('msg-conflito-configusuario');
                        this.$root.showMessage('error', msg, true);
                    } else {
                        this.$root.showMessage('error', 'msg-erro-load', true);
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getUsersConfigsByNameAndValue() {
            /* Esse metodo trás todos os usuarios que estão utilizando essa config com esse valor */
            this.service
                .getAllUsersConfigsByValueAndName(
                    this.parametrizacaoUsuario.nome,
                    this.parametrizacaoUsuario.valorOriginal
                )
                .then((r) => {
                    if (r.content) this.usrsConfigs = r.content;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.carregarVendedoresSelected();
                });
        },
        clearSelect(value, select) {
            if (value.length == 0) {
                if (select == 'vendedores') this.vendedoresSelected = [];
            }
        },
        searchConfigs(search) {
            this.configs = [];
            this.loadConfigs(search);
        },
        loadConfigs(search) {
            this.isLoading = true;
            this.serviceConfig
                .findAllCombo(search)
                .then((value) => {
                    if (value.status === 200) {
                        if (value.content) {
                            value.content.map((e) => {
                                this.configs.push({
                                    id: e.idconfig,
                                    label: e.label || e.nome || '',
                                    nome: e.nome,
                                    descricao: e.descricao,
                                    tipo: e.tipo,
                                    situacao: e.situacao,
                                    idcategoriaconfig: e.idcategoriaconfig,
                                });
                            });

                            this.configSelected = this.configs[0];

                            this.newRenderInput(this.configSelected);
                            this.descricao = this.configSelected.descricao;
                        }
                    } else {
                        this.configs = [];
                        this.configSelected = {};
                        this.$root.showMessage('error', 'msg-erro-load');
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        onCleanConfigs(val) {
            this.options = [];
            this.selected = null;
            if (val) {
                this.newRenderInput(val);
                this.descricao = val.descricao;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 15px !important;
    height: 100%;

    span {
        font-size: 13px;
    }

    .conteudo-parametrizacao {
        display: flex;
        align-items: center;
        padding: 20px 0px;
        flex-direction: column;

        .conteudo-parametrizacao-descricao {
            width: 70%;
        }

        .conteudo-parametrizacao-valor {
            display: flex;
            align-items: center;
            flex-direction: row;
            width: 80%;
            margin-top: 15px;

            span {
                margin-right: 10px;
            }

            div {
                width: 100%;
            }
        }
    }
}
</style>
